import {
  getCanonicalConditionValue,
  normalizeConditionValue,
} from "../generated/productConditions";

export function collapseConditionSeparators(value: string): string {
  return normalizeConditionValue(value).replace(/[\s_-]+/g, "-");
}

function resolveCanonical(
  productTypeSlug: string,
  value: string,
): string | undefined {
  const collapsed = collapseConditionSeparators(value);
  return (
    getCanonicalConditionValue(productTypeSlug, value) ??
    getCanonicalConditionValue(productTypeSlug, collapsed) ??
    getCanonicalConditionValue(productTypeSlug, collapsed.replace(/-/g, " ")) ??
    getCanonicalConditionValue(productTypeSlug, collapsed.replace(/-/g, ""))
  );
}

export function normalizeConditionForFilter(
  value: string,
  productTypeSlug?: string | null,
): string {
  if (!productTypeSlug) return collapseConditionSeparators(value);
  const canonical = resolveCanonical(productTypeSlug, value);
  return collapseConditionSeparators(canonical ?? value);
}
